//
//
//
//
//
//
//

export default {
  name: 'expansion-panel',

  props: {
    expand: Boolean
  },

  computed: {
    params () {
      return {
        expand: this.expand
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/expansion-panel/ExpansionPanel.vue